import clsx from 'clsx';
import React from 'react'

interface IStyledH1Heading {
  fontColor: string;
  content: string;
  customColor: string;
  diffText: string;
  className?: string;
}

const StyledH1Heading: React.FC<IStyledH1Heading> = ({ fontColor, content, customColor, diffText, className }) => {
  return (
    <h1 className={clsx(`${fontColor} font-display font-semibold tracking-tight text-3xl md:text-4xl lg:text-[56px] leading-[1.1] md:leading-[1.08]`, className)}>
      {content} {" "}
      <span className={`${customColor}`}>
        {diffText}
      </span>
    </h1>
  );
};

export default StyledH1Heading
